import type { App } from "vue";
import {
  DashboardDataSourceImpl,
  dashboardDataSourceKey,
} from "./data/datasources/dashboard_datasource";

/**
 * Initialize the Dashboard module
 * This module handles the main dashboard and home page
 */
export function initDashboardModule(app: App) {
  app.provide(dashboardDataSourceKey, new DashboardDataSourceImpl());
}
